"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.whenRouterChange = whenRouterChange;
exports.writeFrameData = writeFrameData;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

var firebase = _interopRequireWildcard(require("firebase/app"));

var _lodash = _interopRequireDefault(require("lodash"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _utils = require("../utils");

var _runtime = _interopRequireDefault(require("../utils/runtime"));

var _storage = _interopRequireDefault(require("../utils/storage"));

var _compatibility = require("../compatibility");

var _path = require("../utils/path");

var _device = require("../utils/device");

var _transport = require("../transport");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TDigest = require('tdigest').TDigest;

var digest = new TDigest();
var timeList = [];
var N = 100; //阀值

var SLOW_FLAG = 16; //ms

var FREEZE_FLAG = 700; //ms

var LOCAL_STORAGE_NAME = 'LOCAL_STORAGE_FRAME_11a7e25822';
var lastFrameTime = (0, _utils.tryCall)(function () {
  return performance.getEntriesByType('paint').find(function (i) {
    return i.name === "first-paint";
  }).startTime;
}) || 0;
var metrics; // 部分网上摘抄
// 直观感受，不同帧率的体验：
// - 帧率能够达到 50 ～ 60 FPS 的动画将会相当流畅，让人倍感舒适；
// - 帧率在 30 ～ 50 FPS 之间的动画，因各人敏感程度不同，舒适度因人而异；
// - 帧率在 30 FPS 以下的动画，让人感觉到明显的卡顿和不适感；
// - 帧率波动很大的动画，亦会使人感觉到卡顿。
//初始化进来

function init() {
  (0, _utils.tryCall)(function () {
    if (!!performance.now) {
      loop(performance.now());
    }
  }, false); // 初始化检查数据

  checkLocalStorageData(); //离开页面检查数据

  window.addEventListener("beforeunload", function () {
    writeFrameData();
  });
} //路由变化进来


function whenRouterChange() {
  // API 兼容性检查，不支持raf设备不采集数据
  if (!window.performance || !window.localStorage || !window.requestAnimationFrame) {
    return false;
  }

  digest.reset();
  checkLocalStorageData();
}

function writeFrameData() {
  if (metrics) {
    _storage.default.set({
      key: LOCAL_STORAGE_NAME,
      metrics: metrics,
      url: (0, _path.getUrl)()
    });
  }
}

function loop(timestamp) {
  if (lastFrameTime === 0) {
    lastFrameTime = timestamp;
  }

  var eachFrameTime = timestamp - lastFrameTime;
  timeList.push(eachFrameTime); //FIXME 最后一次不满100的数据会被丢弃

  if (timeList.length === N) {
    var X = timeList.splice(0, N).sort();
    digest.push(X);
    digest.compress();
    metrics = {
      // average: getThreeDecimals(X.reduce((arr, cur) => arr + cur, 0) / N),
      frame_50: (0, _utils.getThreeDecimals)(digest.percentile(0.5)),
      frame_90: (0, _utils.getThreeDecimals)(digest.percentile(0.9)),
      frame_95: (0, _utils.getThreeDecimals)(digest.percentile(0.95)),
      frame_99: (0, _utils.getThreeDecimals)(digest.percentile(0.99)) // slow_percent: getThreeDecimals(X.filter(cur => cur > SLOW_FLAG).length / N),
      // freeze_precent: getThreeDecimals(X.filter(cur => cur > FREEZE_FLAG).length / N),

    };
  }

  lastFrameTime = timestamp;
  window.requestAnimationFrame(loop); // 标记统计成功

  return true;
}

function checkLocalStorageData() {
  var storageDataStr = _storage.default.get({
    key: LOCAL_STORAGE_NAME
  });

  if (storageDataStr) {
    var data = JSON.parse(storageDataStr);
    record(data);

    _storage.default.clear({
      key: LOCAL_STORAGE_NAME
    });
  } //路由切换是可以拿到当前页面的数据


  if (metrics) {
    // storage.set({key: LOCAL_STORAGE_NAME, metrics, pathname: window.location.pathname})
    record({
      metrics: metrics
    });
  }
}

function record(_ref) {
  var metrics = _ref.metrics,
      url = _ref.url;
  var pathname;

  if (url) {
    pathname = (0, _urlParse.default)(url).pathname;
  }

  (0, _transport.transport)({
    endPoints: [_constants.FIREBASE_ENDPOINT_NAME, _constants.PROMETHEUS_ENDPOINT_NAME],
    type: 'frame',
    url: url,
    traceName: "frame_".concat((0, _path.getRouteName)(pathname)),
    message: {
      metrics: _objectSpread({
        duration: metrics.frame_50
      }, _lodash.default.pick(metrics, ['frame_90', 'frame_95', 'frame_99'])),
      attributes: {
        device_level: (0, _device.getDeviceLevel)()
      }
    }
  });
}